import { type SidekickMessage, type SidekickMessageDraft } from 'apis/aiAgents';

import { type MimUIMessage } from './sdk/structuredResponse';

export const toUIMessage = (message: SidekickMessage): MimUIMessage => ({
  id: message.messageId,
  role: message.role,
  parts: message.parts,
});

export const toSidekickMessageDraft = (
  message: MimUIMessage,
): SidekickMessageDraft => ({
  messageId: message.id,
  role: message.role,
  parts: message.parts,
});

export const prependOlder = (
  older: MimUIMessage[],
  current: MimUIMessage[],
): MimUIMessage[] => {
  const rendered = new Set(current.map((message) => message.id));

  return [...older.filter((message) => !rendered.has(message.id)), ...current];
};
